import config from 'config';

const hook = config.enableCusomterTokenManagement
  ? require('./useCustomerTokenSdk')
  : require('./useCustomerTokenLegacy');

export const useCustomerToken = hook.useCustomerToken;
